/** @jsx jsx */
import { jsx } from '@emotion/react';

// eslint-disable-next-line import/no-cycle
import { CARD_LIST_BREAKPOINTS_CONFIG, ShowMoreGridSectionPlaceholder } from '@coursera-web/cds-labs';
import type { GridConfig } from '@coursera-web/cds-labs';

import { breakpoints, useMediaQuery } from '@coursera/cds-core';

import { styles as CollectionStyles } from 'bundles/collections-common/components/ProductCardCollection';
import { useStatusTagRedesignExperimentVariant } from 'bundles/product-card/components/utils/getStatusTagRedesignExperimentVariant';
import { ProductCardV2Placeholder } from 'bundles/search-common/components/search-cards/Placeholder';

type Props = {
  hideTitle?: boolean;
  hideButton?: boolean;
  itemsGridConfig?: GridConfig;
  defaultRows?: number;
  defaultMobileRows?: number;
  shouldShowListView?: boolean;
};

const ProductCardCollectionPlaceholder = ({
  defaultRows = 1,
  defaultMobileRows = 2,
  shouldShowListView,
  ...props
}: Props) => {
  const isMobile = useMediaQuery(breakpoints.down('xs'));
  const isTablet = useMediaQuery(breakpoints.down('sm'));
  const shouldUseListVariant = shouldShowListView ?? (isTablet || isMobile);
  let itemsGridConfig = props.itemsGridConfig;

  if (!itemsGridConfig && shouldUseListVariant) {
    itemsGridConfig = CARD_LIST_BREAKPOINTS_CONFIG;
  }

  const { isBorderlessCard, productCardExperimentVariant } = useStatusTagRedesignExperimentVariant();

  return (
    <ShowMoreGridSectionPlaceholder
      {...props}
      className="rc-ProductCardCollectionPlaceholder"
      itemsGridConfig={itemsGridConfig}
      defaultRows={isMobile ? defaultMobileRows : defaultRows}
      renderPlaceholderItem={() => (
        <div css={CollectionStyles.targetCardWrapper(isBorderlessCard)} data-testid="card-wrapper">
          <ProductCardV2Placeholder
            variant={shouldUseListVariant ? 'list' : 'grid'}
            experimentVariant={productCardExperimentVariant}
          />
        </div>
      )}
    />
  );
};

export default ProductCardCollectionPlaceholder;
